<template>
    <div>
        <button class="btn btn-secondary btn-sm" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span v-if="text">{{ text }}</span>
            <fa-icon v-if="icon" :icon="icon" />
        </button>
        <div class="dropdown-menu dropdown-menu-right">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ButtonDropdown",
        props: ["text", "icon"],
    }
</script>

<style scoped>

</style>
